import { cn } from "@/utils/cn";

export function Button({
  children,
  variant = "primary",
  size = "md",
  isLoading = false,
  rounded = false,
  className = "",
  disabled,
  ...props
}) {
  const baseStyles = cn(
    "font-medium transition-colors duration-200 inline-flex items-center justify-center gap-2",
    rounded ? "rounded-full" : "rounded-lg"
  );

  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-400",
    secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200",
    success: "bg-green-600 text-white hover:bg-green-700",
    danger: "bg-red-600 text-white hover:bg-red-700",
    outline: "border bg-white border-gray-300 text-gray-700 hover:bg-gray-50",
    ghost: "text-gray-700 hover:bg-gray-100",
  };

  const sizes = {
    sm: "p-1.5 text-sm",
    md: "px-4 py-2",
    lg: "px-6 py-3 text-lg",
  };

  return (
    <button
      className={cn(
        baseStyles,
        variants[variant],
        sizes[size],
        isLoading && "opacity-75 cursor-not-allowed",
        className,
        disabled && "cursor-not-allowed"
      )}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
          Loading...
        </div>
      ) : (
        children
      )}
    </button>
  );
}
